import {
    signInByLP,
    signInByRT,
    getUserData,
    confirmPhoneByCode,
} from "../../request";

import {
    checkToken,
    getTokensFromLocalStorage,
    setTokensInLocalStorage,  
    setPhoneAndTokenInLocalStorage,
} from "../../methods";

import {
    showErrorMessage,
    hideErrorMessage,
    openAuthPhoneModal,
    closeAuthPhoneModal
} from "./ui";

//Редактирование формы
export const EDIT_LOGIN = "Edit login";
export const EDIT_PASSWORD = "Edit password";

//Первый шаг авторизации
export const AUTH_START = "Authorization start";
export const CODE_RESEND_START = "Code resend start";
export const CODE_RESEND_GOT_TIMEOUT = "Code resend got timeout";
export const AUTH_SUCCESS = "Authorization success";
export const AUTH_FAILURE = "Authorization failed";
export const LOGIN_FAILURE = "Login failure";
export const SIGN_OUT = "Sign-out called";
export const CLEAR_ERROR = "Clearing authorization error";

//Подтверждение номера телефона
export const RECEIVING_AUTH_TOKENS = "Receiving authorization tokens";
export const AUTH_TOKENS_RECEIVED_SUCCESSFULLY = "Authorization tokens received successfully";
export const FAILED_TO_RECEIVE_AUTH_TOKENS = "Failed to receive authorization tokens";
export const AUTH_TOKENS_SERVER_ERROR = "Server error during tokens receive";
export const UPDATE_CODE_VALUES = "Update confirmation code values";
export const UPDATE_REMAINING_SECONDS = "Update remaining seconds";

//Получение данных пользователя
export const USER_DATA_LOADING_START = "User data loading start";
export const USER_DATA_LOADING_SUCCESS = "User data loading success";
export const USER_DATA_LOADING_FAILED = "Failure during user data load";

//АВТОРИЗАЦИЯ

//Редактирование формы

export const editLogin = value => ({
    type: EDIT_LOGIN,
    payload: { value }
});

export const editPassword = value => ({
    type: EDIT_PASSWORD,
    payload: { value }
});

//Первая часть авторизации
const authStart = () => ({
    type: AUTH_START
});

const resendCodeStart = () => ({
    type: CODE_RESEND_START
});

const authSuccess = (tempToken, phoneNumber) => ({
    type: AUTH_SUCCESS,
    payload: { tempToken, phoneNumber }
});

const resendCodeTimeout = timeout => ({
    type: CODE_RESEND_GOT_TIMEOUT,
    payload: { timeout }
});

const authFailure = () => ({
    type: AUTH_FAILURE,
});

const loginFailure = () => ({
    type: LOGIN_FAILURE,
});

export const clearServerErrors = () => ({ type: CLEAR_ERROR });
  
//Авторизация по логину и паролю
export const signInAsync = (login, password, resend = false) => {
    return async dispatch => {
        if (resend) {
            dispatch(resendCodeStart())
        } else {
            dispatch(authStart());
        }
        let resp;
        try {
            resp = await signInByLP(login, password);
        } catch (err) {
            const errorCode = parseInt(err && err.response && err.response.status, 10);
            //Неверные логин или пароль или пользователь не найден
            if ((errorCode === 400) || (errorCode === 401) || (errorCode === 404)) {
                return dispatch(loginFailure());
            } else {
                return dispatch(authFailure());
            }
        }
        if (!resend) dispatch(openAuthPhoneModal());
        dispatch(hideErrorMessage()); 
        //temp_token - временный токен, который будет послан вместе с полученным кодом
        //phone - номер телефона, на который отправлено смс
        //Приходят при ПЕРВОМ запросе на авторизацию
        //timeout - сколько осталось времени до повторной высылки кода
        //Приходит, если послать запрос на авторизацию во 2 и более раз 
        let tempToken = '', phoneNumber = '';
        let timeout = null;
        if (resp.data) {
            if (resp.data.timeout && !resp.data.temp_token && !resp.data.phone){
                timeout = resp.data.timeout;
                return dispatch(resendCodeTimeout(timeout));
            }
            else {
                //Если не пришел timeout, обновляем временный токен и номер телефона 
                if (resp.data.temp_token && (resp.data.temp_token.length !== 0)) tempToken = resp.data.temp_token;
                if (resp.data.phone && (resp.data.phone.length !== 0)) phoneNumber = resp.data.phone;
                //Сохраним tempToken и phoneNumber в localStorage, чтобы, если пользователь обновит страницу 
                //до того, как пройдет timeout, они не были пустыми
                setPhoneAndTokenInLocalStorage(tempToken, phoneNumber);
                return dispatch(authSuccess(tempToken, phoneNumber));
            }
        }
    };
};

//Вторая часть авторизации
//Подтверждение номера телефона
const receivingAuthTokens = () => ({
    type: RECEIVING_AUTH_TOKENS
});

const authTokensReceivedSuccessfully = (accessToken, refreshToken) => {
    setTokensInLocalStorage(accessToken, refreshToken);
    return {
        type: AUTH_TOKENS_RECEIVED_SUCCESSFULLY,
        payload: {
            accessToken,
            refreshToken
        }
    };
};

const authTokensFailure = () => ({
    type: FAILED_TO_RECEIVE_AUTH_TOKENS,
});

const authTokensServerError = () => ({
    type: AUTH_TOKENS_SERVER_ERROR,
});

export const confirmPhoneAsync = code => {
    return async (dispatch, getState) => {
        dispatch(receivingAuthTokens());
        const currentState = getState();
        const tempToken = currentState.auth.tempToken;
        const data = {code};
        let resp;
        try {
            resp = await confirmPhoneByCode(tempToken, data);
        } catch (err) {
            const errorCode = parseInt(err && err.response && err.response.status, 10);
            //Введен неверный код или пользователь не найден
            if ((errorCode === 400) || (errorCode === 401) || (errorCode === 404)) {
                return dispatch(authTokensFailure());
            } else {
                return dispatch(authTokensServerError());
            }
        }
        dispatch(closeAuthPhoneModal());
        return dispatch(authTokensReceivedSuccessfully(resp.token, resp.refresh_token));
    };
};

//Редактирование полей формы ввода кода
//Пагинация на странице списка клиентов
//number - название инпута, string
export const updateCodeValues = (field, value) => ({
    type: UPDATE_CODE_VALUES,
    payload: {
        field,
        value,
    }
});

export const updateRemainingSeconds = seconds => ({
    type: UPDATE_REMAINING_SECONDS,
    payload: {
        seconds,
    }
});

//ВЫХОД ИЗ ПРОЕКТА
export const signOut = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("prevUrl");
    return {
        type: SIGN_OUT
    };
};
  
//Обновление токена, используется при инициализации приложения и во всех protected методах
export const checkAndRenewTokens = () => {
    return async dispatch => {
        let tokenIsValid = false;
        const tokens = getTokensFromLocalStorage();
        if (tokens.accessToken && (tokens.accessToken !== null)) tokenIsValid = await checkToken(tokens.accessToken);
        //Если accessToken действует, всё сохраняем и уходим
        if (tokenIsValid) return dispatch(authTokensReceivedSuccessfully(tokens.accessToken, tokens.refreshToken));
        
        //Если нет, проверяем refreshToken
        if (tokens.refreshToken && (tokens.refreshToken !== null)) tokenIsValid = await checkToken(tokens.refreshToken);
        //Если он действует, авторизуемся по нему
        if (tokenIsValid) {
            let resp;
            try {
                resp = await signInByRT(tokens.refreshToken);
            } catch (err) {
                return dispatch(signOut());
            }
            return dispatch(authTokensReceivedSuccessfully(resp.data.token, resp.data.refresh_token));
        }
        return dispatch(signOut());
    };
};

//ПОЛУЧЕНИЕ ДАННЫХ ПОЛЬЗОВАТЕЛЯ
const getDataStart = () => ({
    type: USER_DATA_LOADING_START
});

const getDataSuccess = userLogin => ({
    type: USER_DATA_LOADING_SUCCESS,
    payload: {
        userLogin,
    }
});

const getDataFailure = () => ({
    type: USER_DATA_LOADING_FAILED,
});

//Получение данных пользователя
export const getUserDataAsync = () => {
    return async dispatch => {
        dispatch(getDataStart());
        let userData;
        try {
            const accessToken = localStorage.getItem("accessToken");
            userData = await getUserData(accessToken);
        } catch (err) {
            dispatch(showErrorMessage('Ошибка при загрузке данных пользователя'));
            return dispatch(getDataFailure());
        }
        return dispatch(getDataSuccess(userData.login));
    };
};

//Выход при ошибке, если токен не найден в БД
export const checkTokenError = err => {
    return async dispatch => {
        const errorCode = parseInt(err && err.response && err.response.status, 10);
        const errorText = err && err.response && err.response.data && err.response.data.error;
        //Токен действует, но не найден в БД
        if ((errorCode === 404) && (errorText === 'Invalid token')) dispatch(signOut());
    };
};